import React from 'react';
import PropTypes from 'prop-types';

import { Box, Grid, Typography } from '@mui/material';

const PositionDetailsSection = ({ position, location, department, translate, typographySx }) => (
  <Box sx={{ mb: 4 }}>
    <Typography sx={typographySx.sectionHeader}>
      {translate('job.create.confirmation.positionDetails')}
    </Typography>
    <Grid container spacing={{ xs: 2, md: 6 }}>
      <Grid item xs={4} sx={{ minWidth: 0 }}>
        <Typography sx={typographySx.subHeader}>
          {translate('job.create.confirmation.position')}
        </Typography>
        <Typography sx={typographySx.value}>{position || '-'}</Typography>
      </Grid>
      <Grid item xs={4} sx={{ minWidth: 0 }}>
        <Typography sx={typographySx.subHeader}>
          {translate('job.create.confirmation.location')}
        </Typography>
        <Typography sx={typographySx.value}>{location || '-'}</Typography>
      </Grid>
      <Grid item xs={4} sx={{ minWidth: 0 }}>
        <Typography sx={typographySx.subHeader}>
          {translate('job.create.confirmation.department')}
        </Typography>
        <Typography sx={typographySx.value}>{department || '-'}</Typography>
      </Grid>
    </Grid>
  </Box>
);

PositionDetailsSection.propTypes = {
  department: PropTypes.string,
  location: PropTypes.string,
  position: PropTypes.string,
  translate: PropTypes.func.isRequired,
  typographySx: PropTypes.shape({
    sectionHeader: PropTypes.shape({}).isRequired,
    subHeader: PropTypes.shape({}).isRequired,
    value: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default PositionDetailsSection;
